import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ContactUsLink } from '@app/dashboard/interfaces/contact-us.interface';
import { MoveSandbox } from '@app/move/sandboxes/move.sandbox';
import { StringUtils } from '@smooved/core';
import { Svg, SvgIllustration } from '@smooved/ui';
import { PosthogService } from '@app/tracking/posthog.service';

@Component({
    selector: 'app-contact-us',
    templateUrl: `contact-us.component.html`,
    styleUrls: ['contact-us.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactUsComponent {
    @Input() public contactUsLinks: ContactUsLink[];

    public chevronRight = Svg.ChevronRight;
    public readonly svgIllustration = SvgIllustration;
    public readonly StringUtils = StringUtils;

    public moveID$ = this.moveSandbox.id$;

    constructor(
        private readonly moveSandbox: MoveSandbox,
        private readonly posthogService: PosthogService
    ) {}

    public openLiveChat() {
        // @ts-ignore
        window.zE('messenger', 'open');
    }

    public onClick(contactUsLink: ContactUsLink): void {
        this.posthogService.clickContactUs(contactUsLink.contactType);
        if (!contactUsLink.link) this.openLiveChat();
    }
}
